// extracted by mini-css-extract-plugin
export default {"cls1":"TextArea-cls1___01e4d8ac3f036a153bb","cls2":"TextArea-cls2___e62d1a49d962f8cc7b6 TextArea-cls1___01e4d8ac3f036a153bb"};